import React from 'react';
import generateId from '@helpers/generate-id';
import getBlogType from '@helpers/get-blog-type';
// import TagList from '@components/posts-list/tag-list/tag-list';
import { NoImage } from '@components/posts-list/posts-list.shared.styled';
import { PostPreviewGraphqlType } from '@components/posts-list/relative-posts-list';
import Text from '@components/text';
import {
  OverflowContainer,
  StyledImage,
  ViewLink,
  ImageLink,
  ImageContainer,
  TextContainer,
  FeaturedContainer,
  DescriptionContainer,
  // Meta,
} from './feature-post.styled';

const featurePostIdGenerator = generateId();

interface FeaturePostProps {
  post?: PostPreviewGraphqlType;
  blogUrl: string;
  postsType: string;
}

const FeaturePost = ({ post, blogUrl, postsType }: FeaturePostProps): JSX.Element | null => {
  if (!post) {
    return null;
  }

  const { uid, data, type } = post;

  const postId = featurePostIdGenerator.next().value;
  const currentUrl =
    blogUrl === '/' || blogUrl === '/resources/' ? blogUrl : blogUrl.replace(/\/+$/, '');

  return (
    <OverflowContainer>
      <FeaturedContainer key={postId} postsType={postsType}>
        <ImageContainer>
          {data.featured_image?.url ? (
            <ImageLink
              href={`${
                currentUrl === '/' || currentUrl === '/resources/'
                  ? `${getBlogType(type)}`
                  : currentUrl
              }/${uid}`}
              title="View this post"
              postsType={postsType}
            >
              <StyledImage
                url={data.featured_image.url}
                alt={data.featured_image.alt}
                gatsbyImageData={data.featured_image.gatsbyImageData}
                objectFit="cover"
              />
            </ImageLink>
          ) : (
            <NoImage />
          )}
        </ImageContainer>
        <DescriptionContainer>
          <TextContainer>
            {data.title && (
              <Text
                type="title"
                tag="h2"
                fontSize="heading4"
                margin="none"
                fontColor="secondary"
                stringText={data.title.text}
              />
            )}
            <ViewLink
              href={`${
                currentUrl === '/' || currentUrl === '/resources/'
                  ? `${getBlogType(type)}`
                  : currentUrl
              }/${uid}`}
            >
              Read More
            </ViewLink>
          </TextContainer>
          {/* <Meta>
            <TagList tags={tags} blogUrl={postsType === 'guides_post' ? '/blog' : '/guides'} />
          </Meta> */}
        </DescriptionContainer>
      </FeaturedContainer>
    </OverflowContainer>
  );
};

export default FeaturePost;
